import addIndex from "./addIndex";
import map from "./map";

const mapIndexed = addIndex(map);

export default mapIndexed;
